module.exports = __webpack_public_path__ + "img/ch10.956a960f.jpg";